export enum TransitionType {
    LINEAR = 'linear',
    EASE_OUT = 'ease-out',
    EASE_IN = 'ease-in',
    EASE_IN_OUT = 'ease-in-out',
    EASE = 'ease',
}

interface MakeTransitionProps {
    ms: number;
    styles: string[];
    type?: TransitionType;
}

export const makeTransition = ({ ms, styles, type = TransitionType.LINEAR }: MakeTransitionProps) =>
    styles.map((style) => `${style} ${ms}ms ${type}`).join(', ');
